import React, { useContext, useEffect, useState } from "react";
import "./ordersParts.css";
import {
  getOrderDetailsInfo,
  updateOrderDetailsParts,
} from "../../../Services/ordersServices";
import OrderDetailInfo from "../../../../SupplyChainModules/Components/Orders/OrderDetailInfo";
import { HTTP_RESPONSE_CODES } from "../../../../../globals/globals";
import { DropdownsProvider } from "../../../../../contexts/DropdownsContext";
import { NewOrderContext } from "../../../../SupplyChainModules/context/NewOrderContext";
import MultioptionButton from "../../../../../components/Buttons/MultioptionButton";
import { useSnackBar } from "../../../../../hooks/useSnackBar";
export const OrdersParts = ({
  data,
  orderId,
  currency_name,
  odOriginalCost,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [detailDataProcessed, setDetailDataProcessed] = useState(null);
  const { lineNumberInfo } = useContext(NewOrderContext);
  const [bodyData, setBodyData] = useState(null);
  const [edition, setEdition] = useState(false);
  const { infoMsg, successMsg } = useSnackBar();

  // functions

  // function mergePartRequests(data) {
  //   if (data.length === 0) return null;

  //   const requestsMap = new Map();

  //   data.forEach(item => {
  //     const requestId = item.partRequest.id;

  //     if (!requestsMap.has(requestId)) {
  //       requestsMap.set(requestId, {
  //         ...item,
  //         partRequest: {
  //           ...item.partRequest,
  //           partRequestDetailParts: [...item.partRequest.partRequestDetailParts]
  //         }
  //       });
  //     } else {
  //       const existing = requestsMap.get(requestId);

  //       existing.quantityOrder += item.quantityOrder;

  //       const existingDetailIds = new Set(
  //         existing.partRequest.partRequestDetailParts.map(d => d.id)
  //       );

  //       for (const detail of item.partRequest.partRequestDetailParts) {
  //         if (!existingDetailIds.has(detail.id)) {
  //           existing.partRequest.partRequestDetailParts.push(detail);
  //           existingDetailIds.add(detail.id);
  //         }
  //       }
  //     }
  //   });

  //   const mergedArray = Array.from(requestsMap.values());

  //   if (mergedArray.length === 1) {
  //     return mergedArray[0];
  //   }

  //   const combined = {
  //     ...mergedArray[0],
  //     partRequest: mergedArray.map(item => item.partRequest),
  //     quantityOrder: mergedArray.reduce((sum, item) => sum + item.quantityOrder, 0)
  //   };

  //   return combined;
  // }

  function mergePartRequests(data) {
    if (data.length === 0) return null;

    const requestsMap = new Map();

    data.forEach((item) => {
      const requestId = item.partRequest.id;

      if (!requestsMap.has(requestId)) {
        requestsMap.set(requestId, {
          ...item,
          partRequest: {
            ...item.partRequest,
            originalDetailId: item.id,
            partRequestDetailParts: [
              ...item.partRequest.partRequestDetailParts,
            ],
            quantityOrder: item.partRequest.partRequestDetailParts.length,
          },
        });
      } else {
        const existing = requestsMap.get(requestId);

        existing.quantityOrder += item.quantityOrder;

        const existingDetailIds = new Set(
          existing.partRequest.partRequestDetailParts.map((d) => d.id)
        );

        for (const detail of item.partRequest.partRequestDetailParts) {
          if (!existingDetailIds.has(detail.id)) {
            existing.partRequest.partRequestDetailParts.push(detail);
            existingDetailIds.add(detail.id);
          }
        }
      }
    });

    const mergedArray = Array.from(requestsMap.values());

    // Siempre devolvemos partRequest como array
    const result = {
      ...mergedArray[0],
      partRequest: mergedArray.map((item) => item.partRequest),
      quantityOrder: mergedArray.reduce(
        (sum, item) => sum + item.quantityOrder,
        0
      ),
    };

    return result;
  }

  const getDetailInfo = async () => {
    let request = await getOrderDetailsInfo(data?.id, orderId);

    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setDetailDataProcessed(mergePartRequests(request.data.load));
    }
  };

  const updatePartInfo = async () => {
    if (bodyData != null) {
      let request = await updateOrderDetailsParts(bodyData);

      if (request.data.responseCode == HTTP_RESPONSE_CODES.SUCCESS) {
        successMsg("Edited.", "Part Information Edited.");
        setEdition(false);
      }
    }
  };
  useEffect(() => {
    if (isOpen) {
      getDetailInfo();
    }
  }, [isOpen]);

  useEffect(() => {
    if (lineNumberInfo != null && edition) {
      setBodyData(lineNumberInfo);
    }
  }, [lineNumberInfo]);

  const multiOptionsBtn = [
    { label: "Save", icon: "icon-save", id: "save" },
    { label: "Cancel", icon: "icon-cross", id: "cancel", type: "danger" },
  ];

  const buttonsCallback = {
    save: () => updatePartInfo(),
    cancel: () => {
      setEdition(false);
      isOpen && setIsOpen(false);
    },
  };

  return (
    <section className="order-part">
      <section className="order-part-header" onClick={() => setIsOpen(!isOpen)}>
        {/* <div>
          <span class="icon-coloredwarning">
            <span class="path1"></span>
            <span class="path2"></span>
          </span>
        </div> */}
        <p style={{marginLeft : "1rem"}} className="ellipsis">{data?.id || "--"}</p>
        <p className="ellipsis">{data?.part_number || "--"}</p>
        <p className="ellipsis">{data?.description || "--"}</p>
        <p className="ellipsis">
          {data?.quantity_order} {data?.abreviation}
        </p>
        <p className="ellipsis">{data?.quantity_received || "--"}</p>
        <p className="ellipsis">{data?.category || "--"}</p>
        <p className="ellipsis">{data?.sub_category || "--"}</p>
        <p
          className="ellipsis"
          style={{
            background: "var(--black-mid)",
            width: "1.2rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: ".15rem",
            color: "var(--white)",
            borderRadius: ".3rem",
          }}
        >
          {data?.prn_count || "--"}
        </p>
        {/* <p className='ellipsis'>125-569-998</p>
      <p className='ellipsis'>{data?.wp || "--"}</p>
      <p className='ellipsis'>TC {data?.tc_fnd || "--"}</p>  */}
        <p className="ellipsis">2024-10-14</p>
        <p 
          style={{
            color : "var(--blue-300)"
          }}
        >
          {{
            Invoiced: "INV",
            "Partially Invoiced": "P-INV",
            Received: "REC",
            "Pending Inspection": "PI",
            "Order Discrepancy": "OD",
            "Partially Received": "P-REC",
            "Package Intake": "PKG-IN",
            Shipped: "SHP",
            "Partially Shipped": "P-SHP",
            "Vendor Approved": "VA",
            "Sent To Vendor": "STV",
            Authorized: "AUTH",
            Released: "REL",
            Cancelled: "CXL",
            Generation: "GEN",
          }[data?.status] || data?.status}
        </p>
        <div>
          <i className="icon-cart_stock"></i>
        </div>
      </section>
      <section className={`order-part-content ${isOpen ? "open" : ""}`}>
        <section>
          <h3>PN Details Information</h3>
          {edition ? (
            <MultioptionButton
              buttonCallbacks={buttonsCallback}
              buttons={multiOptionsBtn}
            ></MultioptionButton>
          ) : (
            <button
              onClick={() => {
                setEdition(true);
              }}
            >
              <i
                style={{
                  fontSize: ".8rem",
                }}
                className="icon-edit"
              ></i>
              Edit
            </button>
          )}
        </section>
        {detailDataProcessed && isOpen ? (
          <DropdownsProvider>
            <OrderDetailInfo
              orderOriginalCost={odOriginalCost}
              disable={!edition}
              item={detailDataProcessed}
              context="order_management"
              currencyName={currency_name}
            ></OrderDetailInfo>
          </DropdownsProvider>
        ) : null}
      </section>
    </section>
  );
};
